// Browser ONLY logic. Must have the same exports as server.ts
// See: docs/isomorphic-imports.md
import { generateBrowserPageSpeedContextGetter } from '@amp/web-apps-perfkit';
import type { PageSpeedContext } from '@amp/web-apps-perfkit';
import { getContext } from 'svelte';

export { ERROR_SIGIL } from '@amp/web-apps-perfkit';
export type { IPerfkit } from '@amp/web-apps-perfkit';

export {
    setupBrowserPerfkit,
    setPageSpeedContext,
} from '@amp/web-apps-perfkit';
export const getPageSpeedContext: () => PageSpeedContext =
    generateBrowserPageSpeedContextGetter(getContext);
